export default __webpack_public_path__ + "static/media/basic-icon.10075df1.svg";